<template>
  <div class="content">
    <div class="pro-mobile">
      <menu-mobile />
    </div>
    <div class="back-row-frame">
      <div class="v-c-left">
        <div
          ref="vip_type"
          class="mall-dropdown"
          :class="{ active: isActive }"
          @click="toggleDropdown"
        >
          <button class="dropbtn">
            {{ $t('Bao.vip_reward') }}
            <i class="dropbtn-arr" />
          </button>
          <div class="dropdown-content">
            <a @click.stop="showVipRewards">{{ $t('Bao.vip_reward') }}</a>
            <a @click.stop="showBirthdayRewards">{{ $t('Bao.birthday_tag') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="view-card mall-min-h">
      <div v-if="!allProd" class="history-list-content if-no-data">
        <div class="no-data">
          <i>
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
          </i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
      </div>
      <div v-if="showBirthdayGifts" class="view-card-body ticket-list">
        <div
          v-for="prod in birthdayGift"
          :key="prod.id"
          class="ticket-frame"
        >
          <div class="tf-left">
            <div class="bonus-cube">
              <div class="amount">
                {{ Math.floor(prod.amount).toFixed(0) }}
              </div>
              <div class="unit">
                {{ $t('Bao.point_unit') }}
              </div>
            </div>
          </div>
          <div class="tf-right">
            <div class="title">
              {{ prod.name }}
            </div>
            <div class="describe">
              {{ $t('Bao.birthday_rewards') }}
            </div>
            <div class="second-half">
              <div class="describe" />
              <div>
                <a v-if="prod.avaible !== 1" class="btn btn-exchange lock">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-lock.png`)" alt="">
                </a>
                <a v-else class="btn btn-exchange" @click="confirmPurchase(prod)">{{ $t('Bao.redeem') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="view-card-body ticket-list">
        <div
          v-for="prod in allProd"
          :key="prod.id"
          class="ticket-frame"
          @click="showModel(prod)"
        >
          <div class="tf-left">
            <div class="bonus-cube">
              <div class="amount">
                {{ prod.upgrade_prize }}
              </div>
              <div class="unit">
                {{ $t('Bao.point_unit') }}
              </div>
            </div>
          </div>
          <div class="tf-right">
            <div class="title">
              {{ prod.name }}
            </div>
            <div class="describe">
              {{ $t('Bao.vip_notice') }}
            </div>
            <div class="second-half">
              <div class="describe" />
              <div>
                <a v-if="prod.avaible !== 1" class="btn btn-exchange lock">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-lock.png`)" alt="">
                </a>
                <a v-else class="btn btn-exchange">{{ $t('Bao.redeem') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-purchase-modal :is-active="showModal" :selected-prod="selectedProd" @hideModel="hideModel" />
    </div>
  </div>
</template>
<script>
import { showNotice } from '@/utils/tool'
import { getAllProductInfo, purchaseProd } from '@/api/shop'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'
import menuMobile from '@/components/shop/menuMobile'

export default {
  name: 'Rewards',
  components: {
    confirmPurchaseModal,
    menuMobile
  },
  data() {
    return {
      allProd: [],
      birthdayGift: [],
      showModal: false,
      selectedProd: {},
      isActive: false,
      showBirthdayGifts: false
    }
  },
  watch: {
    '$store.state.user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_SHOP_PURCHASE', false)
      }
    }
  },
  created() {
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProductInfo()
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const vip_type = this.$refs.vip_type
      if (this.isActive && vip_type && !vip_type.contains(event.target)) {
        this.isActive = false
      }
    },
    toggleDropdown() {
      this.isActive = !this.isActive
    },
    showBirthdayRewards() {
      this.showBirthdayGifts = true
      this.isActive = false
    },
    showVipRewards() {
      this.showBirthdayGifts = false
      this.isActive = false
    },
    getAllProductInfo() {
      getAllProductInfo().then((response) => {
        this.allProd = response.data.data.data.vip_upgrade
        this.birthdayGift = response.data.data.data.vip_birthday

        if (this.allProd && this.allProd.length > 0) {
          this.allProd = this.allProd.map(prod => ({
            ...prod,
            type: 2,
            type_name: this.$t('Bao.point_type_vip'),
            availBuy: prod.avaible === 1
          }))
        }
      })
        .catch(error => {
          this.allProd = null
          showNotice(error.response.data.msg)
        })
    },
    buyProd(prod) {
      purchaseProd({ id: prod.id, sub_id: prod.sub_id }).then((response) => {
        showNotice(this.$t('Bao.success'))
        this.getAllProductInfo()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    showModel(prod) {
      this.selectedProd = prod
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    },
    confirmPurchase(prod) {
      this.selectedProd = prod
      this.$store.commit('SET_SHOP_PURCHASE', true)
      this.showModal = false
    }
  }
}
</script>

<style scoped>

</style>
